// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Media from "../../primitives/Media.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Spaces from "../../resources/theme/Spaces.res.js";
import * as BigJs from "big.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Customer from "../../modules/Customer/Customer.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as FontFaces from "../../resources/theme/FontFaces.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as DeviceName from "../../modules/Device/DeviceName.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as ReactAria from "react-aria";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Breakpoints from "../../resources/theme/Breakpoints.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as SliderTrack from "../../resources/layout-and-structure/SliderTrack.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as DeviceSelect from "../../modules/Device/DeviceSelect.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as PaymentMethod from "../../modules/PaymentMethod.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as LabelTableCell from "../../modules/TableCell/LabelTableCell.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as SelectDateFilter from "../../resources/selection-and-input/SelectDateFilter.res.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
let nonApplicableStringLiteral = "—";
let Raw = {};
let query = Client.gql(["query DailyCashFlows($shopId: String!, $date: Datetime!)  {\ndailyShopCashFlows(shopId: $shopId, date: $date)  {\n__typename  \nid  \ncreatedAt  \namount  \nkind  \nreason  \nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.dailyShopCashFlows;
  return {
    dailyShopCashFlows: value$1.map(value => {
      let value$1 = value.kind;
      let tmp;
      switch (value$1) {
        case "INFLOW":
          tmp = "INFLOW";
          break;
        case "OUTFLOW":
          tmp = "OUTFLOW";
          break;
        default:
          throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
          };
      }
      let value$2 = value.staff;
      let value$3 = value.device;
      return {
        __typename: value.__typename,
        id: value.id,
        createdAt: Scalar.Datetime.parse(value.createdAt),
        amount: value.amount,
        kind: tmp,
        reason: value.reason,
        staff: !(value$2 == null) ? {
          __typename: value$2.__typename,
          id: value$2.id,
          name: value$2.name
        } : undefined,
        device: {
          __typename: value$3.__typename,
          id: value$3.id,
          name: value$3.name,
          slug: value$3.slug
        }
      };
    })
  };
}
function serialize(value) {
  let value$1 = value.dailyShopCashFlows;
  let dailyShopCashFlows = value$1.map(value => {
    let value$1 = value.device;
    let value$2 = value$1.slug;
    let value$3 = value$1.name;
    let value$4 = value$1.id;
    let value$5 = value$1.__typename;
    let device = {
      __typename: value$5,
      id: value$4,
      name: value$3,
      slug: value$2
    };
    let value$6 = value.staff;
    let staff;
    if (value$6 !== undefined) {
      let value$7 = value$6.name;
      let value$8 = value$6.id;
      let value$9 = value$6.__typename;
      staff = {
        __typename: value$9,
        id: value$8,
        name: value$7
      };
    } else {
      staff = null;
    }
    let value$10 = value.reason;
    let value$11 = value.kind;
    let kind = value$11 === "OUTFLOW" ? "OUTFLOW" : "INFLOW";
    let value$12 = value.amount;
    let value$13 = value.createdAt;
    let value$14 = Scalar.Datetime.serialize(value$13);
    let value$15 = value.id;
    let value$16 = value.__typename;
    return {
      __typename: value$16,
      id: value$15,
      createdAt: value$14,
      amount: value$12,
      kind: kind,
      reason: value$10,
      staff: staff,
      device: device
    };
  });
  return {
    dailyShopCashFlows: dailyShopCashFlows
  };
}
function serializeVariables(inp) {
  return {
    shopId: inp.shopId,
    date: inp.date
  };
}
function makeVariables(shopId, date, param) {
  return {
    shopId: shopId,
    date: date
  };
}
let DailyCashFlowsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let use = include.use;
let DailyCashFlowsQuery_refetchQueryDescription = include.refetchQueryDescription;
let DailyCashFlowsQuery_useLazy = include.useLazy;
let DailyCashFlowsQuery_useLazyWithVariables = include.useLazyWithVariables;
let DailyCashFlowsQuery = {
  DailyCashFlowsQuery_inner: DailyCashFlowsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: DailyCashFlowsQuery_refetchQueryDescription,
  use: use,
  useLazy: DailyCashFlowsQuery_useLazy,
  useLazyWithVariables: DailyCashFlowsQuery_useLazyWithVariables
};
let Raw$1 = {};
let query$1 = Client.gql(["query DailyPayments($shopId: String!, $date: Datetime!)  {\ndailyShopPayments(shopId: $shopId, date: $date)  {\n__typename\n...on InvoicePayment   {\n__typename  \ninvoiceId: id  \ninvoiceCreatedAt: date  \ninvoiceMethod: method  \ninvoiceAmountReceived: amountReceived  \ninvoiceAmountReturned: amountReturned  \ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\ninvoice  {\n__typename  \nid  \nname  \ncustomerName  \nstaff  {\n__typename  \nid  \nname  \n}\n\nsalesReceipt  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\n}\n\n}\n\n...on SalesReceiptPayment   {\n__typename  \nsalesReceiptId: id  \nsalesReceiptCreatedAt: createdAt  \nsalesReceiptMethod: method  \nsalesReceiptAmountReceived: amountReceived  \nsalesReceiptAmountReturned: amountReturned  \nsalesReceipt  {\n__typename  \nid  \nname  \ncustomer  {\n__typename  \nid  \nlastName  \nfirstName  \ncompanyName  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\ninvoice  {\n__typename  \nid  \nname  \ncreatedAt  \n}\n\n}\n\n}\n\n...on RefundReceiptPayment   {\n__typename  \nrefundReceiptId: id  \nrefundReceiptCreatedAt: createdAt  \nrefundReceiptMethod: method  \nrefundReceiptAmountReceived: amountReceived  \nrefundReceiptAmountReturned: amountReturned  \nrefundReceipt  {\n__typename  \nid  \nname  \ncustomer  {\n__typename  \nid  \nlastName  \nfirstName  \ncompanyName  \n}\n\nstaff  {\n__typename  \nid  \nname  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$1(value) {
  let value$1 = value.dailyShopPayments;
  return {
    dailyShopPayments: value$1.map(value => {
      let typename = value["__typename"];
      switch (typename) {
        case "InvoicePayment":
          let value$1 = value.invoiceMethod;
          let tmp;
          switch (value$1) {
            case "AMEX":
              tmp = "AMEX";
              break;
            case "BANK_TRANSFER":
              tmp = "BANK_TRANSFER";
              break;
            case "BARNABY":
              tmp = "BARNABY";
              break;
            case "CASH":
              tmp = "CASH";
              break;
            case "CHEQUE":
              tmp = "CHEQUE";
              break;
            case "CONTACTLESS_AMEX":
              tmp = "CONTACTLESS_AMEX";
              break;
            case "CONTACTLESS_DEBIT_CARD":
              tmp = "CONTACTLESS_DEBIT_CARD";
              break;
            case "CREDIT_MEMO":
              tmp = "CREDIT_MEMO";
              break;
            case "DEBIT_CARD":
              tmp = "DEBIT_CARD";
              break;
            case "DISTANCE_SELLING":
              tmp = "DISTANCE_SELLING";
              break;
            case "EUSKO_CASH":
              tmp = "EUSKO_CASH";
              break;
            case "EUSKO_DIGITAL":
              tmp = "EUSKO_DIGITAL";
              break;
            case "GIFT_VOUCHER":
              tmp = "GIFT_VOUCHER";
              break;
            case "LESHABITUES":
              tmp = "LESHABITUES";
              break;
            case "LYDIA":
              tmp = "LYDIA";
              break;
            case "PAYPAL":
              tmp = "PAYPAL";
              break;
            case "TICKET_RESTAURANT":
              tmp = "TICKET_RESTAURANT";
              break;
            case "TOWN_HALL_GIFT_VOUCHER":
              tmp = "TOWN_HALL_GIFT_VOUCHER";
              break;
            case "WINO_PAY":
              tmp = "WINO_PAY";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          let value$2 = value.device;
          let value$3 = value.invoice;
          let value$4 = value$3.staff;
          let value$5 = value$3.salesReceipt;
          return {
            NAME: "InvoicePayment",
            VAL: {
              __typename: value.__typename,
              invoiceId: value.invoiceId,
              invoiceCreatedAt: Scalar.Datetime.parse(value.invoiceCreatedAt),
              invoiceMethod: tmp,
              invoiceAmountReceived: value.invoiceAmountReceived,
              invoiceAmountReturned: value.invoiceAmountReturned,
              device: {
                __typename: value$2.__typename,
                id: value$2.id,
                name: value$2.name,
                slug: value$2.slug
              },
              invoice: {
                __typename: value$3.__typename,
                id: value$3.id,
                name: value$3.name,
                customerName: value$3.customerName,
                staff: {
                  __typename: value$4.__typename,
                  id: value$4.id,
                  name: value$4.name
                },
                salesReceipt: !(value$5 == null) ? {
                  __typename: value$5.__typename,
                  id: value$5.id,
                  name: value$5.name,
                  createdAt: Scalar.Datetime.parse(value$5.createdAt)
                } : undefined
              }
            }
          };
        case "RefundReceiptPayment":
          let value$6 = value.refundReceiptMethod;
          let tmp$1;
          switch (value$6) {
            case "AMEX":
              tmp$1 = "AMEX";
              break;
            case "BANK_TRANSFER":
              tmp$1 = "BANK_TRANSFER";
              break;
            case "BARNABY":
              tmp$1 = "BARNABY";
              break;
            case "CASH":
              tmp$1 = "CASH";
              break;
            case "CHEQUE":
              tmp$1 = "CHEQUE";
              break;
            case "CONTACTLESS_AMEX":
              tmp$1 = "CONTACTLESS_AMEX";
              break;
            case "CONTACTLESS_DEBIT_CARD":
              tmp$1 = "CONTACTLESS_DEBIT_CARD";
              break;
            case "CREDIT_MEMO":
              tmp$1 = "CREDIT_MEMO";
              break;
            case "DEBIT_CARD":
              tmp$1 = "DEBIT_CARD";
              break;
            case "DISTANCE_SELLING":
              tmp$1 = "DISTANCE_SELLING";
              break;
            case "EUSKO_CASH":
              tmp$1 = "EUSKO_CASH";
              break;
            case "EUSKO_DIGITAL":
              tmp$1 = "EUSKO_DIGITAL";
              break;
            case "GIFT_VOUCHER":
              tmp$1 = "GIFT_VOUCHER";
              break;
            case "LESHABITUES":
              tmp$1 = "LESHABITUES";
              break;
            case "LYDIA":
              tmp$1 = "LYDIA";
              break;
            case "PAYPAL":
              tmp$1 = "PAYPAL";
              break;
            case "TICKET_RESTAURANT":
              tmp$1 = "TICKET_RESTAURANT";
              break;
            case "TOWN_HALL_GIFT_VOUCHER":
              tmp$1 = "TOWN_HALL_GIFT_VOUCHER";
              break;
            case "WINO_PAY":
              tmp$1 = "WINO_PAY";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          let value$7 = value.refundReceipt;
          let value$8 = value$7.customer;
          let tmp$2;
          if (value$8 == null) {
            tmp$2 = undefined;
          } else {
            let value$9 = value$8.lastName;
            let value$10 = value$8.firstName;
            let value$11 = value$8.companyName;
            tmp$2 = {
              __typename: value$8.__typename,
              id: value$8.id,
              lastName: !(value$9 == null) ? value$9 : undefined,
              firstName: !(value$10 == null) ? value$10 : undefined,
              companyName: !(value$11 == null) ? value$11 : undefined
            };
          }
          let value$12 = value$7.staff;
          let value$13 = value$7.device;
          return {
            NAME: "RefundReceiptPayment",
            VAL: {
              __typename: value.__typename,
              refundReceiptId: value.refundReceiptId,
              refundReceiptCreatedAt: Scalar.Datetime.parse(value.refundReceiptCreatedAt),
              refundReceiptMethod: tmp$1,
              refundReceiptAmountReceived: value.refundReceiptAmountReceived,
              refundReceiptAmountReturned: value.refundReceiptAmountReturned,
              refundReceipt: {
                __typename: value$7.__typename,
                id: value$7.id,
                name: value$7.name,
                customer: tmp$2,
                staff: {
                  __typename: value$12.__typename,
                  id: value$12.id,
                  name: value$12.name
                },
                device: {
                  __typename: value$13.__typename,
                  id: value$13.id,
                  name: value$13.name,
                  slug: value$13.slug
                }
              }
            }
          };
        case "SalesReceiptPayment":
          let value$14 = value.salesReceiptMethod;
          let tmp$3;
          switch (value$14) {
            case "AMEX":
              tmp$3 = "AMEX";
              break;
            case "BANK_TRANSFER":
              tmp$3 = "BANK_TRANSFER";
              break;
            case "BARNABY":
              tmp$3 = "BARNABY";
              break;
            case "CASH":
              tmp$3 = "CASH";
              break;
            case "CHEQUE":
              tmp$3 = "CHEQUE";
              break;
            case "CONTACTLESS_AMEX":
              tmp$3 = "CONTACTLESS_AMEX";
              break;
            case "CONTACTLESS_DEBIT_CARD":
              tmp$3 = "CONTACTLESS_DEBIT_CARD";
              break;
            case "CREDIT_MEMO":
              tmp$3 = "CREDIT_MEMO";
              break;
            case "DEBIT_CARD":
              tmp$3 = "DEBIT_CARD";
              break;
            case "DISTANCE_SELLING":
              tmp$3 = "DISTANCE_SELLING";
              break;
            case "EUSKO_CASH":
              tmp$3 = "EUSKO_CASH";
              break;
            case "EUSKO_DIGITAL":
              tmp$3 = "EUSKO_DIGITAL";
              break;
            case "GIFT_VOUCHER":
              tmp$3 = "GIFT_VOUCHER";
              break;
            case "LESHABITUES":
              tmp$3 = "LESHABITUES";
              break;
            case "LYDIA":
              tmp$3 = "LYDIA";
              break;
            case "PAYPAL":
              tmp$3 = "PAYPAL";
              break;
            case "TICKET_RESTAURANT":
              tmp$3 = "TICKET_RESTAURANT";
              break;
            case "TOWN_HALL_GIFT_VOUCHER":
              tmp$3 = "TOWN_HALL_GIFT_VOUCHER";
              break;
            case "WINO_PAY":
              tmp$3 = "WINO_PAY";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          let value$15 = value.salesReceipt;
          let value$16 = value$15.customer;
          let tmp$4;
          if (value$16 == null) {
            tmp$4 = undefined;
          } else {
            let value$17 = value$16.lastName;
            let value$18 = value$16.firstName;
            let value$19 = value$16.companyName;
            tmp$4 = {
              __typename: value$16.__typename,
              id: value$16.id,
              lastName: !(value$17 == null) ? value$17 : undefined,
              firstName: !(value$18 == null) ? value$18 : undefined,
              companyName: !(value$19 == null) ? value$19 : undefined
            };
          }
          let value$20 = value$15.staff;
          let value$21 = value$15.device;
          let value$22 = value$15.invoice;
          return {
            NAME: "SalesReceiptPayment",
            VAL: {
              __typename: value.__typename,
              salesReceiptId: value.salesReceiptId,
              salesReceiptCreatedAt: Scalar.Datetime.parse(value.salesReceiptCreatedAt),
              salesReceiptMethod: tmp$3,
              salesReceiptAmountReceived: value.salesReceiptAmountReceived,
              salesReceiptAmountReturned: value.salesReceiptAmountReturned,
              salesReceipt: {
                __typename: value$15.__typename,
                id: value$15.id,
                name: value$15.name,
                customer: tmp$4,
                staff: {
                  __typename: value$20.__typename,
                  id: value$20.id,
                  name: value$20.name
                },
                device: {
                  __typename: value$21.__typename,
                  id: value$21.id,
                  name: value$21.name,
                  slug: value$21.slug
                },
                invoice: !(value$22 == null) ? {
                  __typename: value$22.__typename,
                  id: value$22.id,
                  name: value$22.name,
                  createdAt: Scalar.Datetime.parse(value$22.createdAt)
                } : undefined
              }
            }
          };
        default:
          throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
          };
      }
    })
  };
}
function serialize$1(value) {
  let value$1 = value.dailyShopPayments;
  let dailyShopPayments = value$1.map(value => {
    let variant = value.NAME;
    if (variant === "InvoicePayment") {
      let value$1 = value.VAL;
      let value$2 = value$1.invoice;
      let value$3 = value$2.salesReceipt;
      let salesReceipt;
      if (value$3 !== undefined) {
        let value$4 = value$3.createdAt;
        let value$5 = Scalar.Datetime.serialize(value$4);
        let value$6 = value$3.name;
        let value$7 = value$3.id;
        let value$8 = value$3.__typename;
        salesReceipt = {
          __typename: value$8,
          id: value$7,
          name: value$6,
          createdAt: value$5
        };
      } else {
        salesReceipt = null;
      }
      let value$9 = value$2.staff;
      let value$10 = value$9.name;
      let value$11 = value$9.id;
      let value$12 = value$9.__typename;
      let staff = {
        __typename: value$12,
        id: value$11,
        name: value$10
      };
      let value$13 = value$2.customerName;
      let value$14 = value$2.name;
      let value$15 = value$2.id;
      let value$16 = value$2.__typename;
      let invoice = {
        __typename: value$16,
        id: value$15,
        name: value$14,
        customerName: value$13,
        staff: staff,
        salesReceipt: salesReceipt
      };
      let value$17 = value$1.device;
      let value$18 = value$17.slug;
      let value$19 = value$17.name;
      let value$20 = value$17.id;
      let value$21 = value$17.__typename;
      let device = {
        __typename: value$21,
        id: value$20,
        name: value$19,
        slug: value$18
      };
      let value$22 = value$1.invoiceAmountReturned;
      let value$23 = value$1.invoiceAmountReceived;
      let value$24 = value$1.invoiceMethod;
      let invoiceMethod = value$24 === "LESHABITUES" ? "LESHABITUES" : value$24 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$24 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$24 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$24 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$24 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$24 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$24 === "CHEQUE" ? "CHEQUE" : value$24 === "LYDIA" ? "LYDIA" : value$24 === "DEBIT_CARD" ? "DEBIT_CARD" : value$24 === "EUSKO_CASH" ? "EUSKO_CASH" : value$24 === "BARNABY" ? "BARNABY" : value$24 === "PAYPAL" ? "PAYPAL" : value$24 === "AMEX" ? "AMEX" : value$24 === "CASH" ? "CASH" : value$24 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$24 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$24 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
      let value$25 = value$1.invoiceCreatedAt;
      let value$26 = Scalar.Datetime.serialize(value$25);
      let value$27 = value$1.invoiceId;
      return {
        __typename: "InvoicePayment",
        invoiceId: value$27,
        invoiceCreatedAt: value$26,
        invoiceMethod: invoiceMethod,
        invoiceAmountReceived: value$23,
        invoiceAmountReturned: value$22,
        device: device,
        invoice: invoice
      };
    }
    if (variant === "RefundReceiptPayment") {
      let value$28 = value.VAL;
      let value$29 = value$28.refundReceipt;
      let value$30 = value$29.device;
      let value$31 = value$30.slug;
      let value$32 = value$30.name;
      let value$33 = value$30.id;
      let value$34 = value$30.__typename;
      let device$1 = {
        __typename: value$34,
        id: value$33,
        name: value$32,
        slug: value$31
      };
      let value$35 = value$29.staff;
      let value$36 = value$35.name;
      let value$37 = value$35.id;
      let value$38 = value$35.__typename;
      let staff$1 = {
        __typename: value$38,
        id: value$37,
        name: value$36
      };
      let value$39 = value$29.customer;
      let customer;
      if (value$39 !== undefined) {
        let value$40 = value$39.companyName;
        let companyName = value$40 !== undefined ? value$40 : null;
        let value$41 = value$39.firstName;
        let firstName = value$41 !== undefined ? value$41 : null;
        let value$42 = value$39.lastName;
        let lastName = value$42 !== undefined ? value$42 : null;
        let value$43 = value$39.id;
        let value$44 = value$39.__typename;
        customer = {
          __typename: value$44,
          id: value$43,
          lastName: lastName,
          firstName: firstName,
          companyName: companyName
        };
      } else {
        customer = null;
      }
      let value$45 = value$29.name;
      let value$46 = value$29.id;
      let value$47 = value$29.__typename;
      let refundReceipt = {
        __typename: value$47,
        id: value$46,
        name: value$45,
        customer: customer,
        staff: staff$1,
        device: device$1
      };
      let value$48 = value$28.refundReceiptAmountReturned;
      let value$49 = value$28.refundReceiptAmountReceived;
      let value$50 = value$28.refundReceiptMethod;
      let refundReceiptMethod = value$50 === "LESHABITUES" ? "LESHABITUES" : value$50 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$50 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$50 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$50 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$50 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$50 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$50 === "CHEQUE" ? "CHEQUE" : value$50 === "LYDIA" ? "LYDIA" : value$50 === "DEBIT_CARD" ? "DEBIT_CARD" : value$50 === "EUSKO_CASH" ? "EUSKO_CASH" : value$50 === "BARNABY" ? "BARNABY" : value$50 === "PAYPAL" ? "PAYPAL" : value$50 === "AMEX" ? "AMEX" : value$50 === "CASH" ? "CASH" : value$50 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$50 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$50 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
      let value$51 = value$28.refundReceiptCreatedAt;
      let value$52 = Scalar.Datetime.serialize(value$51);
      let value$53 = value$28.refundReceiptId;
      return {
        __typename: "RefundReceiptPayment",
        refundReceiptId: value$53,
        refundReceiptCreatedAt: value$52,
        refundReceiptMethod: refundReceiptMethod,
        refundReceiptAmountReceived: value$49,
        refundReceiptAmountReturned: value$48,
        refundReceipt: refundReceipt
      };
    }
    let value$54 = value.VAL;
    let value$55 = value$54.salesReceipt;
    let value$56 = value$55.invoice;
    let invoice$1;
    if (value$56 !== undefined) {
      let value$57 = value$56.createdAt;
      let value$58 = Scalar.Datetime.serialize(value$57);
      let value$59 = value$56.name;
      let value$60 = value$56.id;
      let value$61 = value$56.__typename;
      invoice$1 = {
        __typename: value$61,
        id: value$60,
        name: value$59,
        createdAt: value$58
      };
    } else {
      invoice$1 = null;
    }
    let value$62 = value$55.device;
    let value$63 = value$62.slug;
    let value$64 = value$62.name;
    let value$65 = value$62.id;
    let value$66 = value$62.__typename;
    let device$2 = {
      __typename: value$66,
      id: value$65,
      name: value$64,
      slug: value$63
    };
    let value$67 = value$55.staff;
    let value$68 = value$67.name;
    let value$69 = value$67.id;
    let value$70 = value$67.__typename;
    let staff$2 = {
      __typename: value$70,
      id: value$69,
      name: value$68
    };
    let value$71 = value$55.customer;
    let customer$1;
    if (value$71 !== undefined) {
      let value$72 = value$71.companyName;
      let companyName$1 = value$72 !== undefined ? value$72 : null;
      let value$73 = value$71.firstName;
      let firstName$1 = value$73 !== undefined ? value$73 : null;
      let value$74 = value$71.lastName;
      let lastName$1 = value$74 !== undefined ? value$74 : null;
      let value$75 = value$71.id;
      let value$76 = value$71.__typename;
      customer$1 = {
        __typename: value$76,
        id: value$75,
        lastName: lastName$1,
        firstName: firstName$1,
        companyName: companyName$1
      };
    } else {
      customer$1 = null;
    }
    let value$77 = value$55.name;
    let value$78 = value$55.id;
    let value$79 = value$55.__typename;
    let salesReceipt$1 = {
      __typename: value$79,
      id: value$78,
      name: value$77,
      customer: customer$1,
      staff: staff$2,
      device: device$2,
      invoice: invoice$1
    };
    let value$80 = value$54.salesReceiptAmountReturned;
    let value$81 = value$54.salesReceiptAmountReceived;
    let value$82 = value$54.salesReceiptMethod;
    let salesReceiptMethod = value$82 === "LESHABITUES" ? "LESHABITUES" : value$82 === "TICKET_RESTAURANT" ? "TICKET_RESTAURANT" : value$82 === "DISTANCE_SELLING" ? "DISTANCE_SELLING" : value$82 === "CONTACTLESS_DEBIT_CARD" ? "CONTACTLESS_DEBIT_CARD" : value$82 === "EUSKO_DIGITAL" ? "EUSKO_DIGITAL" : value$82 === "TOWN_HALL_GIFT_VOUCHER" ? "TOWN_HALL_GIFT_VOUCHER" : value$82 === "CONTACTLESS_AMEX" ? "CONTACTLESS_AMEX" : value$82 === "CHEQUE" ? "CHEQUE" : value$82 === "LYDIA" ? "LYDIA" : value$82 === "DEBIT_CARD" ? "DEBIT_CARD" : value$82 === "EUSKO_CASH" ? "EUSKO_CASH" : value$82 === "BARNABY" ? "BARNABY" : value$82 === "PAYPAL" ? "PAYPAL" : value$82 === "AMEX" ? "AMEX" : value$82 === "CASH" ? "CASH" : value$82 === "GIFT_VOUCHER" ? "GIFT_VOUCHER" : value$82 === "CREDIT_MEMO" ? "CREDIT_MEMO" : value$82 === "WINO_PAY" ? "WINO_PAY" : "BANK_TRANSFER";
    let value$83 = value$54.salesReceiptCreatedAt;
    let value$84 = Scalar.Datetime.serialize(value$83);
    let value$85 = value$54.salesReceiptId;
    return {
      __typename: "SalesReceiptPayment",
      salesReceiptId: value$85,
      salesReceiptCreatedAt: value$84,
      salesReceiptMethod: salesReceiptMethod,
      salesReceiptAmountReceived: value$81,
      salesReceiptAmountReturned: value$80,
      salesReceipt: salesReceipt$1
    };
  });
  return {
    dailyShopPayments: dailyShopPayments
  };
}
function serializeVariables$1(inp) {
  return {
    shopId: inp.shopId,
    date: inp.date
  };
}
function makeVariables$1(shopId, date, param) {
  return {
    shopId: shopId,
    date: date
  };
}
let DailyPaymentsQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};
let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});
let use$1 = include$1.use;
let DailyPaymentsQuery_refetchQueryDescription = include$1.refetchQueryDescription;
let DailyPaymentsQuery_useLazy = include$1.useLazy;
let DailyPaymentsQuery_useLazyWithVariables = include$1.useLazyWithVariables;
let DailyPaymentsQuery = {
  DailyPaymentsQuery_inner: DailyPaymentsQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  refetchQueryDescription: DailyPaymentsQuery_refetchQueryDescription,
  use: use$1,
  useLazy: DailyPaymentsQuery_useLazy,
  useLazyWithVariables: DailyPaymentsQuery_useLazyWithVariables
};
function toLabel(value) {
  if (typeof value === "object") {
    if (value.TAG === "ReceiptTransformed") {
      return I18n.t("Receipts & refunds");
    } else {
      return I18n.t("Invoices & credit notes");
    }
  }
  switch (value) {
    case "Receipt":
      return I18n.t("Receipts & refunds");
    case "Invoice":
      return I18n.t("Invoices & credit notes");
    case "Cashflow":
      return I18n.t("Cash activities");
  }
}
let values = ["Receipt", "Invoice", "Cashflow"];
let FlowType = {
  toLabel: toLabel,
  values: values
};
function cashFlowsRowsFromQueryData(data) {
  return data.dailyShopCashFlows.map(data => {
    let match = data.kind;
    return {
      id: data.id,
      flowType: "Cashflow",
      name: match === "OUTFLOW" ? {
        value: I18n.t("Outflow")
      } : {
        value: I18n.t("Inflow")
      },
      createdAt: data.createdAt,
      amount: data.kind === "OUTFLOW" ? -data.amount : data.amount,
      paymentMethod: "Cash",
      customerNameOrReason: data.reason,
      staffName: Stdlib_Option.mapOr(data.staff, nonApplicableStringLiteral, param => param.name),
      device: {
        id: data.device.id,
        label: DeviceName.format(DeviceName.decode(data.device.slug, data.device.name))
      }
    };
  });
}
function safeSubstract(a, b) {
  return BigJs.Big(a).minus(BigJs.Big(b)).toNumber();
}
function paymentRowsFromQueryData(data) {
  return data.dailyShopPayments.map(data => {
    let variant = data.NAME;
    if (variant === "InvoicePayment") {
      let payment = data.VAL;
      let match = payment.invoice.salesReceipt;
      return {
        id: payment.invoiceId,
        flowType: match !== undefined ? {
          TAG: "InvoiceTransformed",
          initialSalesReceiptId: match.id,
          initialSalesReceiptName: match.name,
          initialSalesReceiptCreatedAt: match.createdAt
        } : "Invoice",
        name: {
          value: payment.invoice.name
        },
        createdAt: payment.invoiceCreatedAt,
        amount: safeSubstract(payment.invoiceAmountReceived, payment.invoiceAmountReturned),
        paymentMethod: PaymentMethod.fromRawValue(payment.invoiceMethod),
        customerNameOrReason: payment.invoice.customerName,
        staffName: payment.invoice.staff.name,
        device: {
          id: payment.device.id,
          label: DeviceName.format(DeviceName.decode(payment.device.slug, payment.device.name))
        }
      };
    }
    if (variant === "RefundReceiptPayment") {
      let payment$1 = data.VAL;
      return {
        id: payment$1.refundReceiptId,
        flowType: "Receipt",
        name: {
          value: payment$1.refundReceipt.name
        },
        createdAt: payment$1.refundReceiptCreatedAt,
        amount: safeSubstract(payment$1.refundReceiptAmountReceived, payment$1.refundReceiptAmountReturned),
        paymentMethod: PaymentMethod.fromRawValue(payment$1.refundReceiptMethod),
        customerNameOrReason: Stdlib_Option.getOr(Stdlib_Option.flatMap(payment$1.refundReceipt.customer, param => Customer.makeName(param.firstName, param.lastName, param.companyName)), nonApplicableStringLiteral),
        staffName: payment$1.refundReceipt.staff.name,
        device: {
          id: payment$1.refundReceipt.device.id,
          label: DeviceName.format(DeviceName.decode(payment$1.refundReceipt.device.slug, payment$1.refundReceipt.device.name))
        }
      };
    }
    let payment$2 = data.VAL;
    let match$1 = payment$2.salesReceipt.invoice;
    let match$2 = payment$2.salesReceipt.customer;
    return {
      id: payment$2.salesReceiptId,
      flowType: match$1 !== undefined ? {
        TAG: "ReceiptTransformed",
        paymentId: payment$2.salesReceipt.id,
        transformedInvoiceName: match$1.name,
        transformedInvoiceCreatedAt: match$1.createdAt
      } : "Receipt",
      name: {
        value: payment$2.salesReceipt.name
      },
      createdAt: payment$2.salesReceiptCreatedAt,
      amount: safeSubstract(payment$2.salesReceiptAmountReceived, payment$2.salesReceiptAmountReturned),
      paymentMethod: PaymentMethod.fromRawValue(payment$2.salesReceiptMethod),
      customerNameOrReason: match$2 !== undefined ? Stdlib_Option.getOr(Customer.makeName(match$2.firstName, match$2.lastName, match$2.companyName), nonApplicableStringLiteral) : nonApplicableStringLiteral,
      staffName: payment$2.salesReceipt.staff.name,
      device: {
        id: payment$2.salesReceipt.device.id,
        label: DeviceName.format(DeviceName.decode(payment$2.salesReceipt.device.slug, payment$2.salesReceipt.device.name))
      }
    };
  });
}
function mergeRowsByCreatedAt(cashFlowsRows, paymentsRows) {
  return Belt_Array.concatMany([cashFlowsRows, paymentsRows]).toSorted((current, next) => next.createdAt.getTime() - current.createdAt.getTime()).filter(row => {
    let match = row.flowType;
    if (typeof match !== "object" || match.TAG !== "InvoiceTransformed") {
      return true;
    } else {
      return DateHelpers.isSameDay(match.initialSalesReceiptCreatedAt, row.createdAt);
    }
  });
}
function addCountersToRows(rows) {
  let isRowsPaymentJoined = (rowA, rowB) => {
    if (rowA.name.value === rowB.name.value) {
      return rowA.device.id === rowB.device.id;
    } else {
      return false;
    }
  };
  let rowsWithOnlyCounts = Stdlib_Array.reduce(rows, [], (acc, current) => {
    let count_0 = acc.filter(row => isRowsPaymentJoined(row, current)).length + 1 | 0;
    let count = [count_0, 0];
    let newrecord = {
      ...current.name
    };
    let row_id = current.id;
    let row_flowType = current.flowType;
    let row_name = (newrecord.count = count, newrecord);
    let row_createdAt = current.createdAt;
    let row_amount = current.amount;
    let row_paymentMethod = current.paymentMethod;
    let row_customerNameOrReason = current.customerNameOrReason;
    let row_staffName = current.staffName;
    let row_device = current.device;
    let row = {
      id: row_id,
      flowType: row_flowType,
      name: row_name,
      createdAt: row_createdAt,
      amount: row_amount,
      paymentMethod: row_paymentMethod,
      customerNameOrReason: row_customerNameOrReason,
      staffName: row_staffName,
      device: row_device
    };
    return Belt_Array.concatMany([acc, [row]]);
  });
  let rowsWithFullCounts = rowsWithOnlyCounts.map(row => {
    let count = Stdlib_Option.map(row.name.count, count => [count[0], rows.filter(current => isRowsPaymentJoined(row, current)).length]);
    let newrecord = {
      ...row.name
    };
    return {
      id: row.id,
      flowType: row.flowType,
      name: (newrecord.count = count, newrecord),
      createdAt: row.createdAt,
      amount: row.amount,
      paymentMethod: row.paymentMethod,
      customerNameOrReason: row.customerNameOrReason,
      staffName: row.staffName,
      device: row.device
    };
  });
  return rowsWithFullCounts.map(row => {
    let newrecord = {
      ...row.name
    };
    let match = row.name.count;
    let match$1 = row.flowType;
    let tmp;
    if (match !== undefined) {
      let exit = 0;
      if (typeof match$1 !== "object") {
        if (match$1 === "Receipt") {
          exit = 1;
        } else {
          tmp = undefined;
        }
      } else if (match$1.TAG === "ReceiptTransformed") {
        exit = 1;
      } else {
        tmp = undefined;
      }
      if (exit === 1) {
        tmp = match[1] > 1 ? row.name.count : undefined;
      }
    } else {
      tmp = undefined;
    }
    newrecord.count = tmp;
    return {
      id: row.id,
      flowType: row.flowType,
      name: newrecord,
      createdAt: row.createdAt,
      amount: row.amount,
      paymentMethod: row.paymentMethod,
      customerNameOrReason: row.customerNameOrReason,
      staffName: row.staffName,
      device: row.device
    };
  });
}
function sortRowsByTime(rows, direction) {
  return rows.toSorted((current, next) => {
    if (direction === "ascending") {
      return current.createdAt.getTime() - next.createdAt.getTime();
    } else {
      return next.createdAt.getTime() - current.createdAt.getTime();
    }
  });
}
function sortRowsByAmount(rows, direction) {
  if (direction === "ascending") {
    return rows.toSorted((current, next) => Primitive_float.compare(current.amount, next.amount));
  } else {
    return rows.toSorted((current, next) => Primitive_float.compare(next.amount, current.amount));
  }
}
function filterPaymentsTransformed(initialRows, rows) {
  return rows.filter(row => {
    let match = row.flowType;
    if (typeof match !== "object") {
      return true;
    }
    if (match.TAG === "ReceiptTransformed") {
      return true;
    }
    let initialSalesReceiptId = match.initialSalesReceiptId;
    return !initialRows.some(current => {
      let match = current.flowType;
      if (typeof match !== "object" || match.TAG !== "ReceiptTransformed") {
        return false;
      } else {
        return initialSalesReceiptId === match.paymentId;
      }
    });
  });
}
function filterRowsByFlowType(rows, flowTypeFilter) {
  return rows.filter(row => {
    let match = row.flowType;
    if (flowTypeFilter === undefined) {
      return true;
    }
    if (typeof flowTypeFilter === "object") {
      return false;
    }
    switch (flowTypeFilter) {
      case "Receipt":
        if (typeof match !== "object") {
          return match === "Receipt";
        } else {
          return match.TAG === "ReceiptTransformed";
        }
      case "Invoice":
        if (typeof match !== "object") {
          return match === "Invoice";
        } else {
          return match.TAG === "InvoiceTransformed";
        }
      case "Cashflow":
        if (typeof match !== "object") {
          return match === "Cashflow";
        } else {
          return false;
        }
    }
  });
}
function filterRowsByDevice(rows, deviceFilter) {
  if (deviceFilter.length !== 0) {
    return rows.filter(row => deviceFilter.some(param => row.device.id === param.id));
  } else {
    return rows;
  }
}
function keyExtractor(row) {
  return row.id;
}
let TableRow = {
  cashFlowsRowsFromQueryData: cashFlowsRowsFromQueryData,
  safeSubstract: safeSubstract,
  paymentRowsFromQueryData: paymentRowsFromQueryData,
  mergeRowsByCreatedAt: mergeRowsByCreatedAt,
  addCountersToRows: addCountersToRows,
  sortRowsByTime: sortRowsByTime,
  sortRowsByAmount: sortRowsByAmount,
  filterPaymentsTransformed: filterPaymentsTransformed,
  filterRowsByFlowType: filterRowsByFlowType,
  filterRowsByDevice: filterRowsByDevice,
  keyExtractor: keyExtractor
};
let initialState_filters = {
  devices: []
};
let initialState_sortDescriptor = {
  column: "time",
  direction: "descending"
};
let initialState = {
  filters: initialState_filters,
  searchQuery: "",
  sortDescriptor: initialState_sortDescriptor,
  asyncResult: "NotAsked"
};
function make(state, action) {
  switch (action.TAG) {
    case "MergeAsyncResultsChanged":
      let asyncResult = action._1;
      let cashFlowsAsyncResult = action._0;
      let mergedAsyncResults;
      let exit = 0;
      if (typeof cashFlowsAsyncResult !== "object" || cashFlowsAsyncResult.TAG !== "Done") {
        exit = 1;
      } else {
        let cashFlowsData = cashFlowsAsyncResult._0;
        if (cashFlowsData.TAG === "Ok") {
          if (typeof asyncResult !== "object" || asyncResult.TAG !== "Done") {
            mergedAsyncResults = "Loading";
          } else {
            let paymentsData = asyncResult._0;
            if (paymentsData.TAG === "Ok") {
              let cashFlowsRows = cashFlowsRowsFromQueryData(cashFlowsData._0);
              let paymentsRows = paymentRowsFromQueryData(paymentsData._0);
              let mergedRows = mergeRowsByCreatedAt(cashFlowsRows, paymentsRows);
              let rowsWithCounts = addCountersToRows(mergedRows);
              mergedAsyncResults = {
                TAG: "Done",
                _0: {
                  TAG: "Ok",
                  _0: rowsWithCounts
                }
              };
            } else {
              exit = 1;
            }
          }
        } else {
          mergedAsyncResults = {
            TAG: "Done",
            _0: {
              TAG: "Error",
              _0: undefined
            }
          };
        }
      }
      if (exit === 1) {
        mergedAsyncResults = typeof asyncResult !== "object" || asyncResult.TAG !== "Done" || asyncResult._0.TAG === "Ok" ? "Loading" : {
          TAG: "Done",
          _0: {
            TAG: "Error",
            _0: undefined
          }
        };
      }
      return {
        filters: state.filters,
        searchQuery: state.searchQuery,
        sortDescriptor: state.sortDescriptor,
        asyncResult: mergedAsyncResults
      };
    case "FiltersChanged":
      return {
        filters: action._0,
        searchQuery: state.searchQuery,
        sortDescriptor: state.sortDescriptor,
        asyncResult: state.asyncResult
      };
    case "SearchQueryChanged":
      return {
        filters: state.filters,
        searchQuery: action._0,
        sortDescriptor: state.sortDescriptor,
        asyncResult: state.asyncResult
      };
    case "SortingChanged":
      let sortDescriptor = action._0;
      let sortedAsyncResult = AsyncResult.mapOk(state.asyncResult, rows => {
        switch (sortDescriptor.column) {
          case "amount":
            return sortRowsByAmount(rows, sortDescriptor.direction);
          case "time":
            return sortRowsByTime(rows, sortDescriptor.direction);
          default:
            return rows;
        }
      });
      return {
        filters: state.filters,
        searchQuery: state.searchQuery,
        sortDescriptor: sortDescriptor,
        asyncResult: sortedAsyncResult
      };
  }
}
let Reducer = {
  initialState: initialState,
  make: make
};
function isBackdatedInvoicePayment(flowType, createdAt) {
  let createdAtUTCMidnight = createdAt.getUTCHours() === 0 && createdAt.getUTCMinutes() === 0 && createdAt.getUTCSeconds() === 0 && createdAt.getUTCMilliseconds() === 0;
  if (typeof flowType !== "object") {
    if (flowType === "Invoice") {
      return createdAtUTCMidnight;
    } else {
      return false;
    }
  } else if (flowType.TAG === "InvoiceTransformed") {
    return createdAtUTCMidnight;
  } else {
    return false;
  }
}
function formatTime(createdAt) {
  let match = I18n.dateTimeFormat(undefined, undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, createdAt);
  if (I18n.locale === "fr-FR") {
    return match.replace(":", "h");
  } else {
    return match;
  }
}
function formatAmount(amount) {
  return I18n.currencyFormat(undefined, "EUR", 2, 2, amount);
}
let tableColumns = [{
  key: "number-and-flow-type",
  name: I18n.t("No. & type of flow"),
  layout: {
    minWidth: {
      NAME: "px",
      VAL: 180
    },
    width: {
      NAME: "fr",
      VAL: 2
    },
    sticky: true
  },
  render: param => {
    let match = param.data;
    let name = match.name;
    let flowType = match.flowType;
    let countBadgeStyle = first => ({
      backgroundColor: first ? "#fefefe" : "#f3f3f7",
      border: "1px solid " + (first ? "#bdbdca" : "#d7d7e0"),
      color: "#25243a",
      cursor: "default",
      fontSize: "8px",
      height: "8.5px",
      marginLeft: "4px",
      padding: "1.5px 4px 2.5px 4px",
      borderRadius: "9px"
    });
    let invoiceTransformed;
    invoiceTransformed = typeof flowType === "object";
    let label = name.value;
    let match$1 = name.count;
    let tmp;
    if (match$1 !== undefined) {
      let count = match$1[0];
      let formattedCount = count.toString() + " / " + match$1[1].toString();
      tmp = JsxRuntime.jsx(Tooltip.make, {
        children: JsxRuntime.jsx("span", {
          children: formattedCount,
          style: countBadgeStyle(count === 1)
        }),
        placement: "top",
        content: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Mixed payment")
        }),
        delay: 0
      });
    } else {
      tmp = null;
    }
    let labelEndElement = JsxRuntime.jsxs(Inline.make, {
      children: [invoiceTransformed ? JsxRuntime.jsx(Tooltip.make, {
        children: JsxRuntime.jsx("svg", {
          children: JsxRuntime.jsx("path", {
            d: "M6.77255742,9.78138085 L6.86213558,9.79225636 C7.13219931,9.84987748 7.30441807,10.1155185 7.24679695,10.3855823 C7.01665848,11.4642155 6.41259534,12.3505288 5.55164239,13.0601156 L5.34845403,13.2207364 C5.32077498,13.2417311 5.29297762,13.2624688 5.26506962,13.282951 L17.28125,13.28125 C17.5573924,13.28125 17.78125,13.5051076 17.78125,13.78125 C17.78125,14.0573924 17.5573924,14.28125 17.28125,14.28125 L5.12075,14.2811335 L5.35114555,14.4532045 C6.24809057,15.1581025 6.89687627,15.9800249 7.18156309,16.9292247 L7.24508231,17.1691822 C7.30697562,17.438299 7.13898783,17.7066357 6.86987107,17.768529 C6.60075431,17.8304223 6.33241763,17.6624345 6.27052432,17.3933178 C6.08759208,16.5979147 5.54117274,15.8744012 4.73323976,15.2394567 C4.36585819,14.9507361 3.96980364,14.7005752 3.57379314,14.4911667 L3.31904909,14.3619248 L3.12838928,14.273892 C2.89406794,14.2290563 2.71875,14.025627 2.71875,13.78125 C2.71875,13.5357901 2.89562516,13.3316416 3.12887437,13.2893057 L3.14775,13.2871335 L3.20977248,13.2657597 C3.3076688,13.2300149 3.44113414,13.176162 3.60080708,13.1031188 C3.99124351,12.9245115 4.3818497,12.6987897 4.74412533,12.4240013 C5.53612454,11.8232648 6.07625346,11.0794072 6.26880968,10.1769177 C6.3136261,9.96686817 6.48428175,9.81600877 6.68498257,9.78644413 L6.77255742,9.78138085 Z M14.1816887,2.53518677 C14.5150751,3.1250057 14.9735248,3.7009764 15.5259566,4.25249003 C15.9631917,4.68899842 16.4332909,5.08493741 16.9032253,5.43183551 C17.134673,5.60268652 17.3220738,5.73010042 17.4469386,5.80981523 C17.6416527,5.87772507 17.78125,6.06318519 17.78125,6.28125 C17.78125,6.51209918 17.6248047,6.70640861 17.4121526,6.76393981 L17.2609602,6.84025659 L16.9489502,7.0139921 C16.5493255,7.24636299 16.1497363,7.51474363 15.7789627,7.81391878 C14.9594087,8.47521235 14.4073862,9.18479684 14.2320378,9.90024333 C14.1663037,10.1684478 13.895593,10.3325825 13.6273885,10.2668484 C13.359184,10.2011143 13.1950494,9.93040361 13.2607834,9.66219913 C13.498015,8.69426068 14.176759,7.82178502 15.1510014,7.03567417 C15.2594395,6.94817611 15.3697479,6.86326687 15.4814357,6.78098437 L3.21875,6.78125 C2.94260763,6.78125 2.71875,6.55739237 2.71875,6.28125 C2.71875,6.00510763 2.94260763,5.78125 3.21875,5.78125 L15.7267876,5.78199919 C15.4170871,5.52677652 15.1121319,5.25239191 14.8194382,4.96018468 C14.2070224,4.34878674 13.6932951,3.70336843 13.3111325,3.02725569 C13.1752514,2.78685823 13.2599787,2.48182419 13.5003761,2.34594311 C13.7407736,2.21006203 14.0458077,2.2947893 14.1816887,2.53518677 Z",
            fill: "#25243A"
          }),
          height: "13",
          width: "15",
          viewBox: "0 0 20 20"
        }),
        placement: "top",
        content: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Transformed into invoice")
        }),
        delay: 0
      }) : null, tmp],
      space: "xxsmall"
    });
    let sublabel;
    sublabel = typeof flowType !== "object" ? undefined : flowType.TAG === "ReceiptTransformed" ? flowType.transformedInvoiceName : flowType.initialSalesReceiptName;
    return JsxRuntime.jsx(LabelTableCell.make, {
      label: label,
      labelEndElement: labelEndElement,
      sublabel: sublabel,
      inPrimaryColumn: true
    });
  }
}, {
  key: "time",
  name: I18n.t("Time"),
  layout: {
    minWidth: {
      NAME: "px",
      VAL: 80
    }
  },
  allowsSorting: true,
  render: param => {
    let match = param.data;
    let createdAt = match.createdAt;
    let flowType = match.flowType;
    let ref = React.createRef();
    let invoiceBackdated = isBackdatedInvoicePayment(flowType, createdAt);
    let label = invoiceBackdated ? Placeholder.NA.text : formatTime(createdAt);
    let labelVariation = invoiceBackdated ? "subdued" : "neutral";
    let labelEndElement;
    if (invoiceBackdated) {
      labelEndElement = JsxRuntime.jsx(Offset.make, {
        children: JsxRuntime.jsx(TooltipIcon.make, {
          children: JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("analytics_cashflow_page.table.time_column.backdated_invoice_payment.tooltip.text")
          }),
          variation: "quiet_info",
          altTriggerRef: ref,
          iconSize: 14
        }),
        top: -0.5,
        left: 2,
        width: 14,
        height: 14
      });
    } else if (typeof flowType !== "object" || flowType.TAG !== "ReceiptTransformed") {
      labelEndElement = null;
    } else {
      let formattedSecondaryCreatedAtDate = I18n.t("Transformed into invoice at") + " " + formatTime(flowType.transformedInvoiceCreatedAt);
      labelEndElement = JsxRuntime.jsx(Offset.make, {
        children: JsxRuntime.jsx(TooltipIcon.make, {
          children: JsxRuntime.jsx(Tooltip.Span.make, {
            text: formattedSecondaryCreatedAtDate
          }),
          variation: "quiet_info",
          altTriggerRef: ref,
          iconSize: 14
        }),
        top: -0.5,
        left: 2,
        width: 14,
        height: 14
      });
    }
    return JsxRuntime.jsx(LabelTableCell.make, {
      label: label,
      labelVariation: labelVariation,
      labelEndElement: labelEndElement,
      ref: ref
    });
  }
}, {
  key: "amount",
  name: I18n.t("Amount"),
  layout: {
    minWidth: {
      NAME: "px",
      VAL: 125
    },
    margin: "xlarge",
    alignX: "flexEnd"
  },
  allowsSorting: true,
  render: param => {
    let amount = param.data.amount;
    let labelVariation = amount < 0 ? "negative" : "neutral";
    let label = formatAmount(amount);
    let newrecord = {
      ...{
        style: {
          display: "flex"
        }
      }
    };
    return JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(LabelTableCell.make, {
      label: label,
      labelBold: true,
      labelVariation: labelVariation
    }), newrecord));
  }
}, {
  key: "payment-method",
  name: I18n.t("Payment method"),
  layout: {
    minWidth: {
      NAME: "px",
      VAL: 132
    },
    width: {
      NAME: "fr",
      VAL: 1.3
    }
  },
  render: param => JsxRuntime.jsx(PaymentMethod.Badge.make, {
    value: param.data.paymentMethod,
    shortened: true,
    bordered: true
  })
}, {
  key: "customer-or-comment",
  name: I18n.t("Customer / Comment"),
  layout: {
    width: {
      NAME: "pct",
      VAL: 20
    }
  },
  render: param => {
    let customerNameOrReason = param.data.customerNameOrReason;
    let tooltip = customerNameOrReason !== nonApplicableStringLiteral ? JsxRuntime.jsx(Tooltip.Span.make, {
      text: customerNameOrReason
    }) : undefined;
    return JsxRuntime.jsx(LabelTableCell.make, {
      label: customerNameOrReason,
      tooltip: tooltip
    });
  }
}, {
  key: "seller",
  name: I18n.t("Seller"),
  layout: {
    width: {
      NAME: "fr",
      VAL: 1.5
    }
  },
  render: param => {
    let staffName = param.data.staffName;
    let tooltip = staffName !== nonApplicableStringLiteral ? JsxRuntime.jsx(Tooltip.Span.make, {
      text: staffName
    }) : undefined;
    return JsxRuntime.jsx(LabelTableCell.make, {
      label: staffName,
      tooltip: tooltip
    });
  }
}, {
  key: "source",
  name: I18n.t("Source"),
  layout: {
    width: {
      NAME: "pct",
      VAL: 15
    }
  },
  render: param => {
    let label = param.data.device.label;
    let tooltip = JsxRuntime.jsx(Tooltip.Span.make, {
      text: label
    });
    return JsxRuntime.jsx(LabelTableCell.make, {
      label: label,
      tooltip: tooltip
    });
  }
}];
function useSearchFiltering(asyncResult, searchQuery) {
  let match = ReactAria.useFilter({
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: true
  });
  let contains = match.contains;
  let endsWith = match.endsWith;
  let startsWith = match.startsWith;
  let normalize = str => str.replace(/\s/g, "");
  return AsyncResult.mapOk(asyncResult, rows => rows.filter(row => {
    if (endsWith(row.name.value, searchQuery) || startsWith(normalize(formatTime(row.createdAt)), searchQuery) || startsWith(normalize(formatAmount(row.amount)), searchQuery) || contains(normalize(PaymentMethod.toShortLabel(row.paymentMethod)), searchQuery) || contains(PaymentMethod.toLabel(row.paymentMethod), searchQuery) || contains(row.customerNameOrReason, searchQuery)) {
      return true;
    } else {
      return contains(row.staffName, searchQuery);
    }
  }));
}
let paddingX = String(Spaces.large) + "px";
let paddingY = String(Spaces.medium) + "px";
let border = "2px";
let borderRadius = "5px";
let wrapperStyle = {
  paddingTop: String(Spaces.normal) + "px",
  paddingBottom: String(Spaces.normal) + "px"
};
function style(borderColor, active, selected, pressed, dimmed, muted) {
  return {
    backgroundColor: "#fefefe",
    boxSizing: "border-box",
    borderRadius: borderRadius,
    borderTopColor: muted ? "transparent" : borderColor,
    borderTopStyle: "solid",
    borderTopWidth: muted ? "0px" : "6px",
    opacity: dimmed ? 0.3 : 1,
    outline: border + ` solid ` + (active ? borderColor : "transparent"),
    outlineOffset: `-` + border,
    transition: `outline-color .075s ease-in, border .075s ease-in, padding .075s ease-in,
                     opacity .1s ease-in,
                     transform 0.2s cubic-bezier(.6, 0.7, .5, 1)`,
    transform: pressed ? "scale3d(0.985, 0.985, 1)" : "initial",
    boxShadow: muted ? `rgba(37, 36, 58, 0.01) 0 6px 10px` : `rgba(37, 36, 58, 0.08) 0 0 10px,
             rgba(37, 36, 58, 0.01) 4px 0 4px,
             rgba(37, 36, 58, 0.01) -4px 0 4px`,
    flex: "1",
    height: "138px",
    minWidth: "180px",
    padding: paddingY + ` ` + paddingX,
    paddingTop: muted ? "20px" : "14px",
    position: "relative",
    zIndex: selected ? 2 : 0
  };
}
function badgeIconStyle(borderColor) {
  return {
    border: `1px solid ` + borderColor,
    bottom: paddingY,
    display: "flex",
    height: "44px",
    position: "absolute",
    right: paddingX,
    width: "44px",
    borderRadius: borderRadius,
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "content-box"
  };
}
let make$1 = React.memo(props => {
  let selected = props.selected;
  let paymentMethod = props.paymentMethod;
  let operationQuantity = props.operationQuantity;
  let match = Hover.use(undefined, undefined, undefined);
  let ref = match[0];
  let match$1 = React.useState(() => false);
  let setPressed = match$1[1];
  let active = selected || match[1];
  let dimmed = props.dimmed && !active;
  let muted = operationQuantity === 0 && !selected;
  let label = PaymentMethod.toLabel(paymentMethod);
  let colorSet = PaymentMethod.ColorSet.make(paymentMethod);
  let fill = muted ? "#bdbdca" : undefined;
  let svg = JsxRuntime.jsx(PaymentMethod.Svg.make, {
    value: paymentMethod,
    fill: fill
  });
  React.useLayoutEffect(() => {
    let domElement = ref.current;
    if (!(domElement == null) && selected) {
      domElement.scrollIntoView({
        inline: "nearest",
        block: "center",
        behavior: "smooth"
      });
    }
  }, [selected]);
  let ariaProps_aria$label = PaymentMethod.toLabel(paymentMethod) + " MetricCard";
  let ariaProps_onPressStart = param => setPressed(param => true);
  let ariaProps_onPressEnd = param => setPressed(param => false);
  let ariaProps = {
    "aria-label": ariaProps_aria$label,
    onPressStart: ariaProps_onPressStart,
    onPressEnd: ariaProps_onPressEnd
  };
  let borderColor = muted ? "#d7d7e0" : colorSet.borderCard;
  let borderIconColor = muted ? "#d7d7e0" : colorSet.borderBadgeAndBorderSvg;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(Touchable.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(Title.make, {
          children: label,
          level: 4,
          weight: "medium"
        }), JsxRuntime.jsx(Title.make, {
          children: formatAmount(props.amount),
          level: 1,
          weight: "bold",
          color: muted ? "#797785" : "#25243a"
        })],
        space: "small"
      }), JsxRuntime.jsx(Box.make, {
        spaceBottom: "normal"
      }), JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Operations"),
          variation: "normal",
          size: "xxsmall"
        }), JsxRuntime.jsx(Title.make, {
          children: operationQuantity.toString(),
          level: 4,
          weight: "bold",
          color: muted ? "#797785" : "#25243a"
        })],
        space: "xsmall"
      }), JsxRuntime.jsx("div", {
        children: svg,
        style: badgeIconStyle(borderIconColor)
      })],
      ariaProps: ariaProps,
      style: Primitive_option.some(style(borderColor, active, selected, match$1[0], dimmed, muted)),
      onPress: props.onPress,
      ref: ref
    }),
    style: wrapperStyle
  });
});
let OperationsMetricCard = {
  paddingX: paddingX,
  paddingY: paddingY,
  border: border,
  borderRadius: borderRadius,
  wrapperStyle: wrapperStyle,
  style: style,
  badgeIconStyle: badgeIconStyle,
  make: make$1
};
function sortByAmountAndQuantity(param, param$1) {
  let amountComparison = Primitive_float.compare(Math.abs(param$1[1]), Math.abs(param[1]));
  let operationQuantityComparison = Primitive_float.compare(param$1[2], param[2]);
  if (amountComparison !== 0) {
    return amountComparison;
  } else {
    return operationQuantityComparison;
  }
}
function safeAdd(a, b) {
  let factor = Math.pow(10, 2);
  let a$1 = a * factor;
  let b$1 = b * factor;
  let added = a$1 + b$1;
  return added / factor;
}
let make$2 = React.memo(props => {
  let onPressMetric = props.onPressMetric;
  let paymentMethodFiltered = props.paymentMethodFiltered;
  let asyncResult = props.asyncResult;
  let trackRef = React.useRef(null);
  let desktopSize = Media.use(Breakpoints.huge);
  ReactUpdateEffect.use1(() => {
    if (Stdlib_Option.isNone(paymentMethodFiltered)) {
      let domElement = trackRef.current;
      if (!(domElement == null)) {
        domElement.scrollTo({
          left: 0,
          behavior: "smooth"
        });
      }
    }
  }, [asyncResult]);
  let metricCardsByAmount = PaymentMethod.values.map(paymentMethod => {
    let filteredAsyncResult = AsyncResult.mapOk(asyncResult, rows => rows.filter(row => row.paymentMethod === paymentMethod));
    let amount;
    if (typeof filteredAsyncResult !== "object") {
      amount = 0;
    } else if (filteredAsyncResult.TAG === "Done") {
      let rows = filteredAsyncResult._0;
      amount = rows.TAG === "Ok" ? Stdlib_Array.reduce(rows._0, 0, (acc, row) => safeAdd(acc, row.amount)) : 0;
    } else {
      amount = 0;
    }
    let operationQuantity;
    if (typeof filteredAsyncResult !== "object" || filteredAsyncResult.TAG !== "Done") {
      operationQuantity = 0;
    } else {
      let rows$1 = filteredAsyncResult._0;
      operationQuantity = rows$1.TAG === "Ok" ? rows$1._0.length : 0;
    }
    return [paymentMethod, amount, operationQuantity];
  }).toSorted(sortByAmountAndQuantity);
  return JsxRuntime.jsx(SliderTrack.make, {
    children: metricCardsByAmount.map(item => {
      let paymentMethod = item[0];
      let selected = paymentMethod === paymentMethodFiltered;
      let dimmed = !selected && Stdlib_Option.isSome(paymentMethodFiltered);
      return JsxRuntime.jsx(make$1, {
        amount: item[1],
        operationQuantity: item[2],
        paymentMethod: paymentMethod,
        selected: selected,
        dimmed: dimmed,
        onPress: param => onPressMetric(paymentMethod)
      }, PaymentMethod.toLabel(paymentMethod));
    }),
    layout: {
      TAG: "ItemsInView",
      _0: {
        base: desktopSize ? 6 : 4
      }
    },
    showIndicator: true,
    trackRef: trackRef
  });
});
let OperationMetrics = {
  OperationsMetricCard: OperationsMetricCard,
  sortByAmountAndQuantity: sortByAmountAndQuantity,
  safeAdd: safeAdd,
  make: make$2
};
let make$3 = React.memo(props => {
  let onDateChange = props.onDateChange;
  let date = props.date;
  let shop = props.shop;
  let dailyShopPaymentsAsyncResult = props.dailyShopPaymentsAsyncResult;
  let dailyShopCashFlowsAsyncResult = props.dailyShopCashFlowsAsyncResult;
  let match = React.useReducer(make, initialState);
  let dispatch = match[1];
  let state = match[0];
  let scope = Auth.useScope();
  let organisationAccount;
  organisationAccount = scope.TAG === "Organisation";
  React.useEffect(() => {
    dispatch({
      TAG: "MergeAsyncResultsChanged",
      _0: dailyShopCashFlowsAsyncResult,
      _1: dailyShopPaymentsAsyncResult
    });
    dispatch({
      TAG: "SortingChanged",
      _0: state.sortDescriptor
    });
  }, [dailyShopCashFlowsAsyncResult, dailyShopPaymentsAsyncResult]);
  let onRequestSearch = queryString => dispatch({
    TAG: "SearchQueryChanged",
    _0: queryString
  });
  let filterPaymentsTransformed$1 = asyncResult => {
    let match = state.asyncResult;
    if (typeof match !== "object") {
      return asyncResult;
    }
    if (match.TAG !== "Done") {
      return asyncResult;
    }
    let initialRows = match._0;
    if (initialRows.TAG !== "Ok") {
      return asyncResult;
    }
    if (typeof asyncResult !== "object") {
      return asyncResult;
    }
    if (asyncResult.TAG !== "Done") {
      return asyncResult;
    }
    let rows = asyncResult._0;
    if (rows.TAG === "Ok") {
      return {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: filterPaymentsTransformed(initialRows._0, rows._0)
        }
      };
    } else {
      return asyncResult;
    }
  };
  let filteredWithoutPaymentMethodAsyncResult = AsyncResult.mapOk(state.asyncResult, rows => filterRowsByFlowType(rows, state.filters.flowType));
  let filteredWithoutPaymentMethodAndWithDeviceAsyncResult = AsyncResult.mapOk(filteredWithoutPaymentMethodAsyncResult, rows => filterRowsByDevice(rows, state.filters.devices));
  let operationMetricsAsyncResult = filterPaymentsTransformed$1(filteredWithoutPaymentMethodAndWithDeviceAsyncResult);
  let filteredAsyncResult = filterPaymentsTransformed$1(AsyncResult.mapOk(filteredWithoutPaymentMethodAndWithDeviceAsyncResult, rows => rows.filter(row => {
    let match = state.filters;
    let paymentMethod = match.paymentMethod;
    if (paymentMethod !== undefined) {
      return paymentMethod === row.paymentMethod;
    } else {
      return true;
    }
  })));
  let searchedAndFilteredAsyncResult = useSearchFiltering(filteredAsyncResult, state.searchQuery);
  let getOperationQuantityFromFlowType = flowType => {
    let match = filterPaymentsTransformed$1(state.asyncResult);
    if (typeof match !== "object") {
      return 0;
    }
    if (match.TAG !== "Done") {
      return 0;
    }
    let rows = match._0;
    if (rows.TAG !== "Ok") {
      return 0;
    }
    let rows$1 = rows._0;
    if (Stdlib_Option.isSome(flowType)) {
      return rows$1.filter(row => {
        let current = row.flowType;
        if (typeof current === "object") {
          if (current.TAG === "ReceiptTransformed") {
            return flowType === "Receipt";
          } else {
            return flowType === "Invoice";
          }
        }
        switch (current) {
          case "Receipt":
            return flowType === "Receipt";
          case "Invoice":
            return flowType === "Invoice";
          case "Cashflow":
            return flowType === current;
        }
      }).length;
    } else {
      return rows$1.length;
    }
  };
  let flowTypeTriggerCountBadgeStyle = active => ({
    backgroundColor: active ? "#bdbdca" : "#d7d7e0",
    border: "1px solid " + (active ? "#a2a1b0" : "#bdbdca"),
    color: "#25243a",
    fontFamily: FontFaces.fontFamilyFromFontName("Archivo"),
    fontSize: "10px",
    height: "10px",
    marginLeft: "2px",
    minWidth: "8px",
    padding: "2px 5px",
    textAlign: "center",
    borderRadius: "10px"
  });
  let flowTypeItemCountBadgeStyle = {
    backgroundColor: "#d7d7e0",
    border: `1px solid ` + "#bdbdca",
    color: "#25243a",
    fontFamily: FontFaces.fontFamilyFromFontName("Archivo"),
    fontSize: "11px",
    height: "10px",
    lineHeight: "12px",
    marginLeft: "2px",
    minWidth: "8px",
    padding: "1.5px 5px 2.5px",
    textAlign: "center",
    borderRadius: "10px"
  };
  let renderHeaderActions = () => {
    if (shop === undefined) {
      return null;
    }
    let defaultItem_1 = I18n.t("All");
    let defaultItem_4 = true;
    let defaultItem = {
      TAG: "Option",
      key: "default",
      label: defaultItem_1,
      value: undefined,
      exclusive: defaultItem_4
    };
    let items = values.map(flowType => ({
      TAG: "Option",
      key: toLabel(flowType),
      label: toLabel(flowType),
      value: flowType
    }));
    let defaultItem_1$1 = I18n.t("All");
    let defaultItem_4$1 = true;
    let defaultItem$1 = {
      TAG: "Option",
      key: "default",
      label: defaultItem_1$1,
      value: undefined,
      exclusive: defaultItem_4$1
    };
    let items$1 = PaymentMethod.values.map(method => ({
      TAG: "Option",
      key: PaymentMethod.toLabel(method),
      label: PaymentMethod.toLabel(method),
      value: method
    }));
    let tmp;
    if (Stdlib_Option.isSome(state.filters.flowType) || Stdlib_Option.isSome(state.filters.paymentMethod) || state.filters.devices.length !== 0) {
      let newrecord = {
        ...{
          style: {
            alignSelf: "center"
          }
        }
      };
      tmp = JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(Scaffold.ResetFiltersButton.make, {
        onPress: () => dispatch({
          TAG: "FiltersChanged",
          _0: {
            devices: []
          }
        })
      }), newrecord));
    } else {
      tmp = null;
    }
    return JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Group.make, {
        children: [organisationAccount ? JsxRuntime.jsx(Auth.SelectSingleShopFilter.make, {
          value: shop
        }) : null, organisationAccount ? JsxRuntime.jsx(CanarySeparator.make, {}) : null, JsxRuntime.jsx(SelectDateFilter.make, {
          label: I18n.t("Date"),
          information: I18n.t("A day starts at 5:00am and ends at 4:59am the next day to include all your sales, even if you close late."),
          disabledFutureDays: true,
          value: date,
          onChange: onDateChange
        }), JsxRuntime.jsx(Select.make, {
          label: I18n.t("Flow type"),
          preset: "filter",
          renderValue: param => {
            let selectedItems = param.selectedItems;
            if (selectedItems.length !== 1) {
              return null;
            }
            let match = selectedItems[0];
            if (match.TAG !== "Option") {
              return null;
            }
            let operationQuantity = getOperationQuantityFromFlowType(match.value);
            return JsxRuntime.jsxs(Inline.make, {
              children: [match.label, JsxRuntime.jsx("span", {
                children: operationQuantity.toString(),
                style: flowTypeTriggerCountBadgeStyle(param.active || param.hovered)
              })],
              space: "xsmall"
            });
          },
          renderItem: param => {
            let item = param.item;
            if (item.TAG !== "Option") {
              return null;
            }
            let operationQuantity = getOperationQuantityFromFlowType(item.value);
            return JsxRuntime.jsxs(Inline.make, {
              children: [item.label, JsxRuntime.jsx("span", {
                children: operationQuantity.toString(),
                style: flowTypeItemCountBadgeStyle
              })],
              space: "xsmall"
            });
          },
          sections: [{
            items: [defaultItem]
          }, {
            items: items,
            title: I18n.t("Flow types")
          }],
          value: {
            TAG: "Single",
            _0: state.filters.flowType
          },
          onChange: change => {
            if (change.TAG !== "Single") {
              return;
            }
            let newrecord = {
              ...state.filters
            };
            dispatch({
              TAG: "FiltersChanged",
              _0: (newrecord.flowType = change._0, newrecord)
            });
          }
        }), JsxRuntime.jsx(Select.make, {
          label: I18n.t("Payment method"),
          preset: "filter",
          renderValue: param => {
            let selectedItems = param.selectedItems;
            let hasAll = selectedItems.some(item => {
              if (item.TAG === "Option") {
                return item.value === undefined;
              } else {
                return false;
              }
            });
            let methods = Stdlib_Array.filterMap(selectedItems, item => {
              if (item.TAG === "Option") {
                return item.value;
              }
            });
            if (hasAll) {
              return I18n.t("All");
            }
            let len = methods.length;
            if (len !== 1) {
              if (len !== 0) {
                return methods.length.toString() + ` ` + I18n.t("selected");
              } else {
                return I18n.t("All");
              }
            }
            let paymentMethod = methods[0];
            return JsxRuntime.jsx(PaymentMethod.Badge.make, {
              value: paymentMethod,
              size: "normal",
              bordered: true
            });
          },
          renderItem: param => {
            let item = param.item;
            if (item.TAG !== "Option") {
              return null;
            }
            let paymentMethod = item.value;
            if (paymentMethod !== undefined) {
              return JsxRuntime.jsx(PaymentMethod.Badge.make, {
                value: paymentMethod,
                bordered: true
              });
            } else {
              return I18n.t("All");
            }
          },
          sections: [{
            items: [defaultItem$1]
          }, {
            items: items$1,
            title: I18n.t("Payment methods")
          }],
          value: {
            TAG: "Single",
            _0: state.filters.paymentMethod
          },
          onChange: selection => {
            if (selection.TAG !== "Single") {
              return;
            }
            let newrecord = {
              ...state.filters
            };
            dispatch({
              TAG: "FiltersChanged",
              _0: (newrecord.paymentMethod = selection._0, newrecord)
            });
          }
        }), JsxRuntime.jsx(DeviceSelect.make, {
          shopId: shop.id,
          value: state.filters.devices,
          onChange: devices => {
            let newrecord = {
              ...state.filters
            };
            dispatch({
              TAG: "FiltersChanged",
              _0: (newrecord.devices = devices, newrecord)
            });
          }
        }), tmp],
        grid: ["auto"],
        grow: false,
        spaceX: "small",
        spaceY: "small",
        alignY: "center"
      }),
      spaceBottom: "normal"
    });
  };
  let searchBar = JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(SearchBar.make, {
      placeholder: I18n.t("Search an information, time, amount..."),
      value: state.searchQuery,
      onChange: onRequestSearch
    }),
    spaceX: "large",
    spaceBottom: "xmedium"
  });
  let match$1 = state.asyncResult;
  let placeholderNoRows;
  if (typeof match$1 !== "object" || match$1.TAG !== "Done") {
    placeholderNoRows = EmptyState.error;
  } else {
    let data = match$1._0;
    if (data.TAG === "Ok") {
      let data$1 = data._0;
      let exit = 0;
      if (typeof searchedAndFilteredAsyncResult !== "object" || searchedAndFilteredAsyncResult.TAG !== "Done") {
        placeholderNoRows = EmptyState.error;
      } else {
        let match$2 = searchedAndFilteredAsyncResult._0;
        if (match$2.TAG === "Ok") {
          if (match$2._0.length !== 0 || data$1.length === 0) {
            exit = 1;
          } else {
            placeholderNoRows = JsxRuntime.jsx(EmptyState.make, {
              illustration: Illustration.noResultFound,
              title: I18n.t("No result were found."),
              text: I18n.t("Try again with another keyword/filter or:"),
              children: JsxRuntime.jsx(Button.make, {
                label: I18n.t("Clear search query and filters"),
                onPress: () => {
                  dispatch({
                    TAG: "SearchQueryChanged",
                    _0: ""
                  });
                  dispatch({
                    TAG: "FiltersChanged",
                    _0: {
                      devices: []
                    }
                  });
                }
              })
            });
          }
        } else {
          placeholderNoRows = EmptyState.error;
        }
      }
      if (exit === 1) {
        placeholderNoRows = data$1.length !== 0 || searchedAndFilteredAsyncResult._0._0.length !== 0 ? EmptyState.error : JsxRuntime.jsx(EmptyState.make, {
          illustration: Illustration.noResultFound,
          title: I18n.t("No result were found."),
          text: I18n.t("as of") + " " + I18n.dateTimeFormat(undefined, "medium", undefined, undefined, undefined, undefined, undefined, undefined, undefined, date)
        });
      }
    } else {
      placeholderNoRows = EmptyState.error;
    }
  }
  let onPressMetric = React.useCallback(paymentMethod => {
    if (state.filters.paymentMethod !== paymentMethod) {
      let newrecord = {
        ...state.filters
      };
      return dispatch({
        TAG: "FiltersChanged",
        _0: (newrecord.paymentMethod = paymentMethod, newrecord)
      });
    }
    let newrecord$1 = {
      ...state.filters
    };
    dispatch({
      TAG: "FiltersChanged",
      _0: (newrecord$1.paymentMethod = undefined, newrecord$1)
    });
  }, [state.filters]);
  return JsxRuntime.jsxs(Page.make, {
    children: [JsxRuntime.jsx(make$2, {
      asyncResult: operationMetricsAsyncResult,
      paymentMethodFiltered: state.filters.paymentMethod,
      onPressMetric: onPressMetric
    }), JsxRuntime.jsx(Box.make, {
      spaceBottom: "small"
    }), JsxRuntime.jsx(TableView.make, {
      data: searchedAndFilteredAsyncResult,
      columns: tableColumns,
      keyExtractor: keyExtractor,
      placeholderEmptyState: placeholderNoRows,
      searchBar: searchBar,
      sortDescriptor: state.sortDescriptor,
      onSortChange: sortDescriptor => dispatch({
        TAG: "SortingChanged",
        _0: sortDescriptor
      })
    })],
    variation: "compact",
    title: I18n.t("Cash flow"),
    renderHeaderActions: renderHeaderActions
  });
});
let AnalyticsCashFlowLoaded = {
  make: make$3
};
function AnalyticsCashFlowPage(props) {
  let shops = Auth.useShops();
  let shop = Stdlib_Option.orElse(Auth.useActiveShop(), shops[0]);
  let match = React.useState(() => {
    let date = new Date();
    date.setHours(5);
    return date;
  });
  let setDate = match[1];
  let date = match[0];
  let dailyShopCashFlowsQuery = use(undefined, undefined, undefined, undefined, "CacheFirst", undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(shop), undefined, {
    shopId: Stdlib_Option.mapOr(shop, "", shop => shop.id),
    date: Scalar.Datetime.serialize(date)
  });
  let dailyShopCashFlowsAsyncResult = AsyncResult.mapError(ApolloHelpers.queryResultToAsyncResult(dailyShopCashFlowsQuery), param => {});
  let dailyShopPaymentsQuery = use$1(undefined, undefined, undefined, undefined, "CacheFirst", undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(shop), undefined, {
    shopId: Stdlib_Option.mapOr(shop, "", shop => shop.id),
    date: Scalar.Datetime.serialize(date)
  });
  let dailyShopPaymentsAsyncResult = AsyncResult.mapError(ApolloHelpers.queryResultToAsyncResult(dailyShopPaymentsQuery), param => {});
  let onDateChange = React.useCallback(date => setDate(param => {
    date.setHours(5);
    return date;
  }), []);
  return JsxRuntime.jsx(make$3, {
    dailyShopCashFlowsAsyncResult: dailyShopCashFlowsAsyncResult,
    dailyShopPaymentsAsyncResult: dailyShopPaymentsAsyncResult,
    shop: shop,
    date: date,
    onDateChange: onDateChange
  });
}
let make$4 = React.memo(AnalyticsCashFlowPage);
let dayHoursShifted = 5;
export { nonApplicableStringLiteral, dayHoursShifted, DailyCashFlowsQuery, DailyPaymentsQuery, FlowType, TableRow, Reducer, isBackdatedInvoicePayment, formatTime, formatAmount, tableColumns, useSearchFiltering, OperationMetrics, AnalyticsCashFlowLoaded, make$4 as make };
/* query Not a pure module */